import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";

export function getUploadResponseError(responseText: string): Error {
    let message = "Upload failed.";
    try {
        const parsed = JSON.parse(responseText) as { message?: string; title?: string };
        message = parsed?.message ?? parsed?.title ?? message;
    } catch {
        // non-JSON body — fall back to the default message
    }
    enqueueSnackbar(message, { variant: "error" });
    return new Error();
}
